import { useMatchMedia } from "@/hooks/use-match-media";
import breakpoints from "@/styles/utils/media.module.scss";

export function useBreakpoint(
	size: "sm" | "md" | "lg" | "xl"
): boolean | undefined {
	return useMatchMedia(`(min-width: ${breakpoints[size]})`);
}
